import { Component } from 'react'
import { withTranslation } from '../hoc/withTranslation';

class Error extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="centervs">
        <h1 style={{ fontFamily: this.props.customDetails?.fontFamily }}>
          Oops!</h1>
        <h2 style={{ fontFamily: this.props.customDetails?.fontFamily }}>
          { t('redirection.titles.somethingWentWrong')}
          </h2>
        {/* <div className="error-details">
          Sorry, an error has occured, Requested page not found!
        </div> */}
      </div>
    )
  }
}

export default withTranslation(Error);